﻿{
  "US": "Stati Uniti",
  "AF": "Afghanistan",
  "AX": "Isole Aland",
  "AL": "Albania",
  "DZ": "Algeria",
  "AS": "Samoa americane",
  "AD": "Andorra",
  "AO": "Angola",
  "AI": "Anguilla",
  "AQ": "Antartide",
  "AG": "Antigua e Barbuda",
  "AR": "Argentina",
  "AM": "Armenia",
  "AW": "Aruba",
  "AU": "Australia",
  "AT": "Austria",
  "AZ": "Azerbaijan",
  "BS": "Bahamas",
  "BH": "Bahrain",
  "BD": "Bangladesh",
  "BB": "Barbados",
  "BY": "Bielorussia",
  "BE": "Belgio",
  "BZ": "Belize",
  "BJ": "Benin",
  "BM": "Bermuda",
  "BT": "Bhutan",
  "BO": "Bolivia",
  "BA": "Bosnia ed Erzegovina",
  "BW": "Botswana",
  "BV": "Isola Bouvet",
  "BR": "Brasile",
  "IO": "Territorio britannico dell'Oceano Indiano",
  "BN": "Brunei Darussalam",
  "BG": "Bulgaria",
  "BF": "Burkina Faso",
  "BI": "Burundi",
  "KH": "Cambogia",
  "CM": "Camerun",
  "CA": "Canada",
  "CV": "Capo Verde",
  "KY": "Isole Cayman",
  "CF": "Repubblica Centrale Africana",
  "TD": "Ciad",
  "CL": "Cile",
  "CN": "Cina",
  "CX": "Isola di Natale",
  "CC": "Isole Cocos (Keeling)",
  "CO": "Colombia",
  "KM": "Comoros",
  "CG": "Congo",
  "CD": "Repubblica Democratica del Congo",
  "CK": "Isole Cook",
  "CR": "Costa Rica",
  "CI": "Costa d’Avorio",
  "HR": "Croazia",
  "CU": "Cuba",
  "CY": "Cipro",
  "CZ": "Repubblica Ceca",
  "DK": "Danimarca",
  "DJ": "Djibouti",
  "DM": "Dominica",
  "DO": "Repubblica Dominicana",
  "EC": "Equador",
  "EG": "Egitto",
  "SV": "El Salvador",
  "GQ": "Guinea Equatoriale",
  "ER": "Eritrea",
  "EE": "Estonia",
  "ET": "Etiopia",
  "FK": "Isole Falkland (Malvine)",
  "FO": "Isole Faroe",
  "FJ": "Fiji",
  "FI": "Finlandia",
  "FR": "Francia",
  "GF": "Guiana francese",
  "PF": "Polinesia francese",
  "TF": "Terre Australi e Antartiche Francesi",
  "GA": "Gabon",
  "GM": "Gambia",
  "GE": "Georgia",
  "DE": "Germania",
  "GH": "Ghana",
  "GI": "Gibilterra",
  "GR": "Grecia",
  "GL": "Groenlandia",
  "GD": "Grenada",
  "GP": "Guadalupa",
  "GU": "Guam",
  "GT": "Guatemala",
  "GG": "Guernsey",
  "GN": "Guinea",
  "GW": "Guinea-Bissau",
  "GY": "Guyana",
  "HT": "Haiti",
  "HM": "Isole Heard e McDonald",
  "VA": "Stato Pontificio (Città del Vaticano)",
  "HN": "Honduras",
  "HK": "Hong Kong",
  "HU": "Ungheria",
  "IS": "Islanda",
  "IN": "India",
  "ID": "Indonesia",
  "IR": "Repubblica Islamica dell'Iran",
  "IQ": "Iraq",
  "IE": "Irlanda",
  "IM": "Isola di Man",
  "IL": "Israele",
  "IT": "Italia",
  "JM": "Giamaica",
  "JP": "Giappone",
  "JE": "Jersey",
  "JO": "Giordania",
  "KZ": "Kazakistan",
  "KE": "Kenya",
  "KI": "Kiribati",
  "KR": "Corea",
  "KW": "Kuwait",
  "KG": "Kyrgyzstan",
  "LA": "Repubblica Popolare Democratica di Laos",
  "LV": "Lettonia",
  "LB": "Libano",
  "LS": "Lesotho",
  "LR": "Liberia",
  "LY": "Jamahiriyya Araba di Libia",
  "LI": "Liechtenstein",
  "LT": "Lituania",
  "LU": "Lussemburgo",
  "MO": "Macao",
  "MK": "Macedonia",
  "MG": "Madagascar",
  "MW": "Malawi",
  "MY": "Malesia",
  "MV": "Maldive",
  "ML": "Mali",
  "MT": "Malta",
  "MH": "Isole Marshall",
  "MQ": "Martinica",
  "MR": "Mauritania",
  "MU": "Mauritius",
  "YT": "Mayotte",
  "MX": "Messico",
  "FM": "Stati Federati della Micronesia",
  "MD": "Moldavia",
  "MC": "Monaco",
  "MN": "Mongolia",
  "ME": "Montenegro",
  "MS": "Monserrato",
  "MA": "Marocco",
  "MZ": "Mozambico",
  "MM": "Myanmar",
  "NA": "Namibia",
  "NR": "Nauru",
  "NP": "Nepal",
  "NL": "Paesi Bassi",
  "AN": "Antille Olandesi",
  "NC": "Nuova Caledonia",
  "NZ": "Nuova Zelanda",
  "NI": "Nicaragua",
  "NE": "Niger",
  "NG": "Nigeria",
  "NU": "Niue",
  "NF": "Norfolk Island",
  "MP": "Isole Marianne Settentrionali",
  "NO": "Norvegia",
  "OM": "Oman",
  "PK": "Pakistan",
  "PW": "Palau",
  "PS": "Territorio della Palestina, Occupata",
  "PA": "Panama",
  "PG": "Papua Nuova Guinea",
  "PY": "Paraguay",
  "PE": "Perù",
  "PH": "Filippine",
  "PN": "Pitcairn",
  "PL": "Polonia",
  "PT": "Portogallo",
  "PR": "Porto Rico",
  "QA": "Qatar",
  "RE": "Riunione",
  "RO": "Romania",
  "RU": "Federazione Russa",
  "RW": "Ruanda",
  "BL": "Saint Barthelemy",
  "SH": "Sant'Elena",
  "KN": "Saint Kitts e Nevis",
  "LC": "Santa Lucia",
  "MF": "Saint Martin",
  "PM": "Saint Pierre e Miquelon",
  "VC": "Saint Vincent e Grenadine",
  "WS": "Samoa",
  "SM": "San Marino",
  "ST": "Sao Tome e Principe",
  "SA": "Arabia Saudita",
  "SN": "Senegal",
  "RS": "Serbia",
  "SC": "Seychelles",
  "SL": "Sierra Leone",
  "SG": "Singapore",
  "SK": "Slovacchia",
  "SI": "Slovenia",
  "SB": "Isole Salomone",
  "SO": "Somalia",
  "ZA": "Sudafrica",
  "GS": "Georgia del Sud e Isole Sandwich",
  "ES": "Spagna",
  "LK": "Sri Lanka",
  "SD": "Sudan",
  "SR": "Suriname",
  "SJ": "Svalbard e Jan Mayen",
  "SZ": "Swaziland",
  "SE": "Svezia",
  "CH": "Svizzera",
  "SY": "Repubblica Araba Siriana",
  "TW": "Taiwan",
  "TJ": "Tajikistan",
  "TZ": "Tanzania",
  "TH": "Tailandia",
  "TL": "Timor-Leste",
  "TG": "Togo",
  "TK": "Tokelau",
  "TO": "Tonga",
  "TT": "Trinidad e Tobago",
  "TN": "Tunisia",
  "TR": "Turchia",
  "TM": "Turkmenistan",
  "TC": "Isole Turks e Caicos",
  "TV": "Tuvalu",
  "UG": "Uganda",
  "UA": "Ucraina",
  "AE": "Emirati Arabi Uniti",
  "GB": "Regno Unito",
  "UM": "Isole esterne degli Stati Uniti d'America",
  "UY": "Uruguay",
  "UZ": "Uzbekistan",
  "VU": "Vanuatu",
  "VE": "Venezuela",
  "VN": "Vietnam",
  "VG": "Isole Vergini, Britanniche",
  "VI": "Isole Vergini, Statunitensi",
  "WF": "Wallis e Futuna",
  "EH": "Sahara Occidentale",
  "YE": "Yemen",
  "ZM": "Zambia",
  "ZW": "Zimbabwe"
}
